var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"form-label"},[_c('small',[_vm._v(_vm._s(_vm.label))])]),_vm._v(" "),_c('input',{staticClass:"form-control rounded-8 sin-borde",attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }